import React from 'react';
import { FormControl, TextField } from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import trLocale from 'date-fns/locale/tr';
import { Controller } from 'react-hook-form';
import { LocalizationProvider, TimePicker } from '@mui/lab';

const TimeInput = React.forwardRef(({
    name,
    label,
    defaultValue,
    control,
    rules,
    error,
    variant = 'outlined',
    margin = 'dense',
    inputFormat = "HH:mm",
    ...props
}, ref) => {
    // Helper function to convert a time string (HH:mm:ss) to a Date object
    const timeStringToDate = (timeString) => {
        if (!timeString) return null;
        const [hours, minutes, seconds] = timeString.split(':').map(Number);
        const date = new Date();
        date.setHours(hours, minutes, seconds || 0, 0);
        return date;
    };

    // Helper function to convert a Date object to a time string (HH:mm:ss)
    const dateToTimeString = (date) => {
        if (!date) return null;
        return date.toTimeString().split(' ')[0]; // Returns HH:mm:ss
    };

    return (
        <FormControl fullWidth variant={variant} margin={margin}>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                rules={rules}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
                        <TimePicker
                            {...props}
                            label={label}
                            value={timeStringToDate(value) || null}
                            onChange={(newValue) => {
                                const timeString = dateToTimeString(newValue);
                                onChange(timeString); // Update the form value as a string
                            }}
                            ampm={false} // 24-hour format
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    error={!!error}
                                    margin={margin}
                                    variant={variant}
                                    helperText={error?.message}
                                    autoComplete="off"
                                    inputRef={ref}
                                />
                            )}
                        />
                    </LocalizationProvider>
                )}
            />
        </FormControl>
    );
});

export default TimeInput;
